import { render, staticRenderFns } from "./PostSingleRelated.vue?vue&type=template&id=0445a0f2&scoped=true&lang=pug&"
import script from "./PostSingleRelated.vue?vue&type=script&lang=js&"
export * from "./PostSingleRelated.vue?vue&type=script&lang=js&"
import style0 from "./PostSingleRelated.vue?vue&type=style&index=0&id=0445a0f2&lang=scss&scoped=true&"
import style1 from "./PostSingleRelated.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445a0f2",
  null
  
)

export default component.exports